import { Box, Chip, Grid, Typography } from '@mui/material';
import _ from 'lodash';
import { generatePath, Link } from 'react-router-dom';
import { APP_URLS } from '../../routes/urls';
import { fonts } from '../../theme/typography';
import { InstituteListItem } from '../../types/institute';
import { WishlistButton } from '../wishlist-button/WishlistButton';
import { createExcerptFromArray, formatToNepaliPrice } from '../../utils/text';
import { moduleCardStyles } from '../../theme/styles/moduleCard';
import { getDefaultImageSrc, loadDefaultImageOnError } from '../../utils/image';

interface InstituteCardProps {
  institute: InstituteListItem;
  tag?: string;
}
export const InstituteCard: React.FC<InstituteCardProps> = ({ institute, tag }) => {
  const renderWishlistButton = () => {
    return <WishlistButton sx={moduleCardStyles.wishlistBtn} moduleId={institute.id} type="institutes" />;
  };

  const renderHeader = (): JSX.Element => {
    return (
      <Box sx={moduleCardStyles.header}>
        <Box sx={moduleCardStyles.headerWithImage}>
          <img
            loading="lazy"
            src={institute.media || getDefaultImageSrc('institute')}
            onError={loadDefaultImageOnError.bind(null, 'institute')}
            alt={`Logo of ${institute.name}`}
          />
          {renderWishlistButton()}
        </Box>
      </Box>
    );
  };

  const getSpecialDiscountOffered = (): string => {
    if (institute.special_discount_offered && institute.discount_unit) {
      if (institute.discount_unit === 'Amount') {
        return formatToNepaliPrice(parseFloat(institute.special_discount_offered.toString()));
      } else {
        return `${institute.special_discount_offered}%`;
      }
    }
    return '';
  };

  const singleInstituteUrl = generatePath(APP_URLS.singleInstitute, { instituteSlug: institute.slug });
  const excerptOfProgramsShortName = createExcerptFromArray(
    _.map(institute.provided_programs, (program) => program.short_name)
  );

  return (
    <Box sx={{ height: 1 }}>
      {tag && <Chip sx={{ borderRadius: '4px 4px 0 0' }} variant="light" color="info" label={tag} />}
      <Box
        sx={[moduleCardStyles.card, { borderTopLeftRadius: tag ? 0 : '0.5rem' }]}
        component={Link}
        to={singleInstituteUrl}
      >
        {renderHeader()}
        <Box sx={{ p: 3 }}>
          {institute.institute_type && (
            <Typography color="secondary" component="div" variant="medium" sx={{ mb: 1.5 }} fontWeight="Medium">
              {institute.institute_type.title}
            </Typography>
          )}
          <Typography variant="large" component="h6" fontFamily={fonts.heading} fontWeight="Bold">
            {institute.name}
          </Typography>
          <Box sx={{ mt: 3 }}>
            <Grid container spacing={0.75} direction="column">
              <Grid item>
                <Typography variant="medium">{institute.address}</Typography>
              </Grid>
              <Grid item>
                <Typography color="secondary" variant="medium">
                  {institute.phone}
                </Typography>
              </Grid>
              <Grid item>
                <Typography color="secondary" variant="medium">
                  {institute.email}
                </Typography>
              </Grid>
              {institute.provided_programs && institute.provided_programs.length > 0 && (
                <Grid item>
                  <Typography component="div" sx={{ mb: 0.5 }} color="secondary" variant="medium">
                    Included Programs:
                  </Typography>
                  <Typography sx={{ color: 'grey.900' }} variant="medium" fontWeight="Bold">
                    {excerptOfProgramsShortName}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Box>
          {institute.discount_unit && institute.special_discount_offered && (
            <Box sx={{ mt: 2.5 }}>
              <Chip
                variant="light"
                color="success"
                sx={moduleCardStyles.discountBadge}
                label={`Scholarship: ${getSpecialDiscountOffered()} on all Programs`}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
